export const TRADE_TYPES = {
    PLAYER: 'T', // Traded Player
    FUTURE_MONEY: 'TFM', // Trade Future Money
    DRAFT_PICK: 'PT', // Draft Pick Trade
} as const

export type TradeType = typeof TRADE_TYPES[keyof typeof TRADE_TYPES] 